import { FormBaseType } from "@green0meter/api-client";

import { REPORT_PAGES } from "@constants";

export const CO2_CONFIG = {
  formBaseType: FormBaseType.Co2,
  welcomeBanner: {
    titleKey: "co2hub.welcome",
    textKey: "co2hub.welcomeText",
    color: "blue",
    icon: "accountant",
  },
  collectData: {
    titleKey: "co2CollectionDataTitle",
    descriptionKey: "co2CollectionDataDescription",
    color: "teal",
    icon: "data-gathering",
    buttonTextKey: "co2CollectionDataButtonStart",
    noFormsTextKey: "collectData.noFormsCreated",
  },
  reports: {
    titleKey: "co2.hub.reports.title",
    type: "co2-reports",
    noReportsTextKey: "co2.hub.reports.noReports",
    fillFormTextKey: "co2.hub.reports.fillForm",
  },
  overview: {
    titleKey: "co2.hub.overview.title",
    dashboardPath: "/co2/dashboard",
    viewDashboardTextKey: "common.viewDashboard",
    reportPageId: REPORT_PAGES.CO2_OVERVIEW_MASTER,
  },
};
